exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".split[data-v-2f9a3da4]{width:100%;height:.8rem;border-top:1px solid $color-row-line;border-bottom:1px solid $color-row-line;background:#f3f5f7}", ""]);

// exports
